import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Logger from "../logger";
import env from "env";
import _ from "lodash";
import { getBrowserLanguage } from "../helpers/getBrowserLocale";

// Custom backend for loading translations from external files
const createHttpBackend = (translationsPath) => ({
  type: "backend",
  read(language, namespace, callback) {
    const url = `${translationsPath}/${language}.json`;
    Logger.of("App.languages.backend").info(
      `[i18n] Fetching translations from: ${url}`,
    );

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((resources) => {
        Logger.of("App.languages.backend").info(
          `[i18n] Loaded translations for ${language}:`,
          Object.keys(resources),
        );

        // Support both flat structure and namespaced structure
        callback(null, resources[namespace] || resources);
      })
      .catch((error) => {
        Logger.of("App.languages.backend").warn({
          url,
          error,
          language,
          namespace,
        });
        callback(error, null);
      });
  },
});

export const getI18nConfig = (translationsJson, options = {}) => {
  
  let defaultLanguage = "en"; // Default to English
  let storedLanguage = localStorage.getItem("selectedLanguage"); // get the selected language from Local Storage
  let browserLanguage = getBrowserLanguage(); // get the current browser's language from locale

  if (env.REACT_APP_ENABLE_LANGUAGES) {
    // Multi-language selection is enabled by the env variable
    let availableLanguages = _.keys(translationsJson);
    
    if (storedLanguage && availableLanguages.includes(storedLanguage)) {
      // Level 1: Language selection from Local Storage
      defaultLanguage = storedLanguage;
    } else if (
      browserLanguage &&
      availableLanguages.includes(browserLanguage)
    ) {
      // Level 2: Language selection from Browser's locale
      defaultLanguage = browserLanguage;
      localStorage.setItem("selectedLanguage", browserLanguage); // update local storage regarding the selected language with the browser's locale language
    }
  }
  
   
  const isLocalDev = process.env.NODE_ENV === "development";
  if (isLocalDev || !options.translationsPath) {
    // LOCAL DEVELOPMENT: Use bundled translations directly (current behavior)
    i18n.use(initReactI18next).init({
      resources: translationsJson,
      lng: defaultLanguage,
      fallbackLng: "en",
      interpolation: {
        skipOnVariables: false,
        escapeValue: false,
      },
    });
  } else {
    // PRODUCTION: Use custom HTTP backend to load translations
    // Note: Do NOT provide 'resources' here, otherwise i18next will use them instead of calling the backend
    i18n
      .use(createHttpBackend(options.translationsPath))
      .use(initReactI18next)
      .init({
        lng: defaultLanguage,
        fallbackLng: "en",
        ns: ["translation"],
        defaultNS: "translation",
        interpolation: {
          skipOnVariables: false,
          escapeValue: false,
        },
        react: {
          useSuspense: false,
        },
      });
  }

  Logger.of("App.languages.init").info(i18n);
  return i18n;
};
